// extracted by mini-css-extract-plugin
export default {"screen_user_controls":"ConfirmActionScreen_screen_user_controls__igYOt","screen_content":"ConfirmActionScreen_screen_content__Z0qKV"};